import axiosInstance from './AxiosInstance';

export async function getPartnerDisbursements(partnerId, page = 1, filters = {}) {
    return axiosInstance.get(`ledger/partners/${partnerId}/disbursements`, { params: { page, ...filters } });
}

export async function getPartnerPayouts(partnerId, page = 1, filters = {}) {
    return axiosInstance.get(`ledger/partners/${partnerId}/payouts`, { params: { page, ...filters } });
}

export async function getPartnerTopUps(partnerId, page = 1, filters = {}) {
    return axiosInstance.get(`ledger/partners/${partnerId}/top-ups`, { params: { page, ...filters } });
}

export async function exportPartnerTopUps(partnerId, filters = {}) {
    return axiosInstance.get(`ledger/partners/${partnerId}/top-ups/export`, {
        params: filters,
        responseType: 'blob',
    });
}

export async function exportPartnerDisbursements(partnerId, filters = {}) {
    return axiosInstance.get(`ledger/partners/${partnerId}/disbursements/export`, {
        params: filters,
        responseType: 'blob',
    });
}

export async function exportPartnerPayouts(partnerId, filters = {}) {
    return axiosInstance.get(`ledger/partners/${partnerId}/payouts/export`, {
        params: filters,
        responseType: 'blob',
    });
}

export async function exportPartnerStatement(partnerId, filters = {}) {
    return axiosInstance.get(`ledger/partners/${partnerId}/statement/export`, {
        params: filters,
        responseType: 'blob',
    });
}

export async function exportUserStatement(userId, filters = {}) {
    return axiosInstance.get(`ledger/users/${userId}/statement/export`, {
        params: filters,
        responseType: 'blob',
    });
}

export async function revealPayoutCounterparty(payoutId) {
    return axiosInstance.get(`ledger/payouts/${payoutId}/counterparty`);
}

export async function getLatestPartnerTopUps(partnerId) {
    return axiosInstance.get(`ledger/partners/${partnerId}/top-ups`, { params: { page: 1, per_page: 5 } });
}

export async function getDeferredTopUpsForWalletActivation(partnerId) {
    return axiosInstance.get(`ledger/partners/${partnerId}/top-ups/deferred-for-wallet-activation`);
}

export async function getUserDisbursements(userId, page = 1, filters = {}) {
    return axiosInstance.get(`ledger/users/${userId}/disbursements`, { params: { page, ...filters } });
}

export async function getUserPayouts(userId, page = 1, filters = {}) {
    return axiosInstance.get(`ledger/users/${userId}/payouts`, { params: { page, ...filters } });
}

export async function getPartnerStatement(partnerId, page = 1, filters = {}) {
    return axiosInstance.get(`ledger/partners/${partnerId}/statement`, { params: { page, ...filters } });
}

export async function getUserStatement(userId, page = 1, filters = {}) {
    return axiosInstance.get(`ledger/users/${userId}/statement`, { params: { page, ...filters } });
}

export async function getChartOfAccounts(page = 1) {
    return axiosInstance.get('ledger/chart-of-accounts', { params: { page } });
}

export async function getChartOfAccountEntries(accountId, page = 1) {
    return axiosInstance.get(`ledger/chart-of-accounts/${accountId}/entries`, { params: { page } });
}

export async function getReconciliationRequiredTopUps(page = 1) {
    return axiosInstance.get('ledger/top-ups/reconciliation-required', { params: { page } });
}

export async function reconcileTopUp(topUpId, data) {
    return axiosInstance.post(`ledger/top-ups/${topUpId}/reconcile`, data);
}

export async function getReconciliationRequiredPayouts(page = 1) {
    return axiosInstance.get('ledger/payouts/reconciliation-required', { params: { page } });
}

export async function reconcilePayout(payoutUniqueId, data) {
    return axiosInstance.post(`ledger/payouts/${payoutUniqueId}/reconcile`, data);
}

export async function getPendingMpesaFeeVariances(page = 1) {
    return axiosInstance.get('ledger/mpesa-fee-variances/pending', { params: { page } });
}

export async function clawBackMpesaFeeVariance(varianceId, data) {
    return axiosInstance.post(`ledger/mpesa-fee-variances/${varianceId}/claw-back`, data);
}

export async function writeOffMpesaFeeVariance(varianceId, data) {
    return axiosInstance.post(`ledger/mpesa-fee-variances/${varianceId}/write-off`, data);
}
